import React from "react";

export default function Section({ children }) {
  return (
    <section className={`px-6 section max-w-screen-md mx-auto`}>
      {children}
    </section>
  );
}
